// Búsqueda IA oculta a nivel de código para este release — no depende de NEXT_PUBLIC_DEFAULT_SEARCH_MODE.
// Oculta el selector de modo (Clásico/IA) en SearchFilterBar y SearchModal, forzando modo clásico
// en desktop y mobile. Para revertir, volver a `true`.
export const SHOW_IA_SEARCH = false

export const operacionOptions = [
	{ value: 'venta', label: 'Comprar' },
	{ value: 'arriendo', label: 'Arrendar' },
]

export const propiedadOptions = [
	{ value: 'departamento', label: 'Departamento' },
	{ value: 'casa', label: 'Casa' },
	{ value: 'oficina', label: 'Oficina' },
	{ value: 'local-comercial', label: 'Local Comercial' },
	{ value: 'terreno', label: 'Terreno' },
	{ value: 'parcela', label: 'Parcela' },
	{ value: 'agricola', label: 'Agrícola' },
	{ value: 'industrial', label: 'Industrial' },
	{ value: 'bodega', label: 'Bodega' },
	{ value: 'estacionamiento', label: 'Estacionamiento' },
	{ value: 'vacacional', label: 'Vacacional' },
]

// Traduce el value de propiedadOptions al slug real usado en la URL SEO
// (formato /{operacion}/{tipoPropiedad}/{seoUrl}, ej. /venta/departamento/metropolitana/las-condes).
// No asumir que coincide siempre con el value: verificar contra las URLs reales del sitio.
export const PROPIEDAD_TYPE_URL_SLUG: Record<string, string> = {
	departamento: 'departamento',
	casa: 'casa',
	oficina: 'oficina',
	'local-comercial': 'local-comercial',
	terreno: 'terreno',
	parcela: 'parcela',
	agricola: 'campo-agricola',
	industrial: 'terreno-industrial',
	bodega: 'bodega',
	estacionamiento: 'estacionamiento',
	vacacional: 'lugar-vacacional',
}
